<div class="card-footer" slot="footer">
    <dx-button label="Zurück" [disabled]="disablePrev" [hidden]="!showPrev" type="secondary-m" (click)="prev()"></dx-button>
    <div></div>
    <dx-button label="Weiter" [disabled]="disableNext" [hidden]="!showNext" type="primary-m" (click)="next()"></dx-button>
</div>
